import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ImageIcon, X } from 'lucide-react';
import { PhotoUploader } from '../PhotoUploader';

/** Maintenance photo grid with device upload + URL paste. */
export const MaintPhotosDialog = ({
  open,
  onOpenChange,
  task,
  onAddUrl,
  onRemove,
  onPreview,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[500px]" data-testid="maint-photo-dialog">
      <DialogHeader>
        <DialogTitle className="font-manrope flex items-center gap-2">
          <ImageIcon className="h-5 w-5" />
          Task Photos - {task?.title}
        </DialogTitle>
      </DialogHeader>

      <div className="space-y-4">
        <PhotoUploader
          kind="maintenance_photo"
          onAdd={onAddUrl}
          testIdPrefix="maint-photo-uploader"
        />

        {task?.photos && task.photos.length > 0 ? (
          <div className="grid grid-cols-3 gap-3">
            {task.photos.map((photo, idx) => (
              <div key={`maint-photo-${photo.slice(-20)}-${idx}`} className="relative group">
                <img
                  src={photo}
                  alt={`Photo ${idx + 1}`}
                  className="w-full h-24 object-cover rounded-lg border border-slate-200 cursor-pointer"
                  onClick={() => onPreview(photo)}
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/100?text=Invalid';
                  }}
                />
                <button
                  onClick={() => onRemove(idx)}
                  className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                  data-testid={`maint-remove-photo-${idx}`}
                  aria-label="Remove photo"
                >
                  <X className="h-3 w-3" />
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-slate-500 text-center py-8">
            No photos yet. Snap or upload before/after photos to document the repair.
          </p>
        )}
      </div>
    </DialogContent>
  </Dialog>
);

export default MaintPhotosDialog;
